import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de/common.json';
import en from './locales/en/common.json';
import fr from './locales/fr/common.json';
import it from './locales/it/common.json';

function detectInitialLanguage(): string {
  try {
    const url = new URL(window.location.href);
    const urlLang = url.searchParams.get('lang');
    if (urlLang && ['en', 'de', 'it', 'fr'].includes(urlLang)) {
      return urlLang;
    }
  } catch (_) {
    // ignore
  }
  const stored = localStorage.getItem('lang');
  if (stored && ['en', 'de', 'it', 'fr'].includes(stored)) return stored;
  return 'en';
}

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      de: { common: de },
      it: { common: it },
      fr: { common: fr },
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
  });

export function setLanguage(lang: string) {
  if (!['en', 'de', 'it', 'fr'].includes(lang)) return;
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem('lang', lang);
    const url = new URL(window.location.href);
    url.searchParams.set('lang', lang);
    window.history.replaceState({}, '', url.toString());
  } catch (_) {
    // ignore
  }
}

export default i18n;


